import { isToday, isTomorrow } from 'date-fns';

export const formatDate = (date: Date | string, options?: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('ru-RU', options).format(typeof date === 'string' ? new Date(date) : date);

export const MONTHS = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

export const getMeetingDate = (date: string) => {
  const validDate = new Date(date);

  if (isToday(validDate)) {
    return 'сегодня';
  }

  if (isTomorrow(validDate)) {
    return 'завтра';
  }

  return `${formatDate(validDate, { weekday: 'short' })}, ${validDate.getDate()} ${MONTHS[validDate.getMonth()]}`;
};
